/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventSceneManagementUpdateIsEditingResponse } from './EventSceneManagementUpdateIsEditingResponse';

export type EventSceneManagementUpdateIsEditingResponseApiRespoonse = {
    data?: EventSceneManagementUpdateIsEditingResponse;
    status?: EventSceneManagementUpdateIsEditingResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventSceneManagementUpdateIsEditingResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

